<div id="modal-container">
  <table id="search-add-tbl">
    <tr style="height: fit-content">
      <th class="search">
        <app-lineitem-filter
          [options]="stdLineItems"
          [selectedValue]="{}"
          [selectedOptionsId]="selectedId"
          [liFilterId]="lineItemInputId"
          [disabled]="disabled"
          [placeholder]="placeholder"
          [showButton]="false"
          cascaderClass="li-modal-cascader"
          [isLIMModal]="isLIMModal"
          [tickers]="tickers"
          (onValueChange)="onLineitemChange($event)"
        ></app-lineitem-filter>
      </th>
      <th>{{ rightHeader }}</th>
    </tr>
    <tr>
      <td class="add">
        <div class="content-heading">
          <div
            class="left-heading"
            [style.visibility]="lineItems.length ? 'visible' : 'hidden'"
          >
            <div
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="menu"
              [ngClass]="{ active: visible }"
              (nzVisibleChange)="onMenuVisibleChange($event)"
              [nzOverlayClassName]="'comp-menu-dropdown'"
              [nzBackdrop]="false"
              id="selectedItem"
            >
              {{ selectedMenuItem }}
              <i nz-icon nzType="down" style="float: right"></i>
            </div>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu class="li-menu-holder">
                <li
                  nz-menu-item
                  *ngFor="let data of lineItems"
                  (click)="onLiSelect($event, data)"
                >
                  {{ data.tab_full_name }}
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div class="right-heading-add" (click)="addAllTickers()">
            <va-icon
              size="small"
              name="plus"
              class="icon va-icon mr-4"
            ></va-icon
            >Add All
          </div>
        </div>
        <app-add-modal-section
          [dataToUse]="recentlyVisited"
          field="name"
          (addData)="addLi($event)"
          [maxHeight]="maxHeight"
        ></app-add-modal-section>
      </td>
      <td class="add">
        <div class="content-heading">
          <div
            class="left-heading"
            [style.color]="
              modalData.length > max || modalData.length < 1
                ? '#e61F00'
                : '#363636'
            "
          >
            Number of selected: {{ modalData && modalData.length }}
          </div>
          <div
            [ngClass]="[
              modalData && modalData.length
                ? 'right-heading-remove'
                : 'greyed-removeall'
            ]"
            (click)="removeAllTickers()"
          >
            <va-icon
              size="small"
              name="close"
              class="icon va-icon mr-4"
            ></va-icon
            >Remove All
          </div>
        </div>
        <app-remove-modal-section
          [dataToUse]="modalData"
          field="name"
          [maxHeight]="maxHeight"
          (removeData)="removeLi($event)"
        ></app-remove-modal-section>
      </td>
    </tr>
  </table>

  <div
    class="mt-12"
    *ngIf="marketItemsData && marketItemsData.length && showAdditionalColumns"
  >
    <div class="modal-bottom-section-title">Additional Display Columns:</div>
    <nz-checkbox-group
      [(ngModel)]="marketItemsData"
      class="modal-market-list-checkbox-wrapper"
    ></nz-checkbox-group>
  </div>

  <div
    class="mt-12"
    *ngIf="ratioDenomData && ratioDenomData.length && showDenomCheckbox"
  >
    <div class="modal-bottom-section-title">
      Valuation Ratio Additional Display Columns:
    </div>
    <nz-checkbox-wrapper (nzOnChange)="handleRatioDenomItemValueChange($event)">
      <div
        *ngFor="let item of ratioDenomData"
        class="modal-footer-checkbox-item"
      >
        <label nz-checkbox [nzValue]="item.name" [ngModel]="item.selected">{{
          item.label
        }}</label>
      </div>
    </nz-checkbox-wrapper>
  </div>

  <!-- <div *nzModalFooter>
    <button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
    <button
      nz-button
      nzType="primary"
      [nzLoading]="isLoading"
      [disabled]="this.modalData.length > 50 ? true : false"
      (click)="updateLineItems()"
    >
      Update
    </button>
  </div> -->
</div>
